import { Pipe, PipeTransform } from '@angular/core';
import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateRoomControlMode',
  standalone: true,
})
export class TranslateRoomControlModePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.ROOMS_CONTROL_MODE[value]) {
      return this.translateService.instant(
        this.customTranslationsService.ROOMS_CONTROL_MODE[value] ?? value
      );
    }

    return value;
  }
}
